import type { IconData } from '@stacksjs/iconify-core'

export const shoppingShippingBox: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 6.1v19.81h32V6.1Zm18.29 18.29H1.52V7.625h16.77Zm6.09 0h-4.57V7.625h3.05v6.09h1.52Zm6.1 0h-4.57V13.715h1.52v-6.09h3.05Z\"/><path fill=\"currentColor\" d=\"M15.24 9.145h1.52v3.05h-1.52Zm-4.57 0h1.52v3.05h-1.52Zm-7.62 12.19h4.57v1.53H3.05Zm0-3.05h4.57v1.53H3.05Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default shoppingShippingBox
